var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "return_order_config_list",
      "columns": _vm.columns,
      "fixed-header": "",
      "data-source": _vm.bounceCfgList,
      "row-key": "service",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_name) + "] ")];
      }
    }, {
      key: "collect_warehouse_list",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.joinText(record.collect_warehouse_list))) + " ")];
      }
    }, {
      key: "service_type_list",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.joinText(record.service_type_list))) + " ")];
      }
    }])
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };